import { useEffect, useState } from 'react';

import useGlobalStore from 'hooks/useGlobalStore';
import useUser from 'hooks/useUser';

const useIsAdmin = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const { fetchUser } = useUser();
    const { getValue } = useGlobalStore({ namespace: 'useCurrentUser' });
    const currentUser = getValue('currentUser');

    const checkIsAdmin = async () => {
        if (!currentUser) {
            return;
        }

        const currentOrgMember = await fetchUser({ id: currentUser.id });

        setIsAdmin(currentOrgMember?.roles?.includes('Admin') ?? false);
    };

    useEffect(() => {
        checkIsAdmin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { isAdmin };
};

export default useIsAdmin;
